const origin = window.location.origin;
var apiBaseUrl = 'https://agchimpapi.azurewebsites.net';
$(document).ready(function () {
    getAgchimpToken();
});
function getAgchimpToken() {
  const cached = localStorage.getItem("agchimpToken");
  console.log(cached);
  if(cached != null){
    console.log('cached is not null')
    if(cached.hasOwnProperty('token')){
      console.log('hasToken');
      const { token, expiresAt } = JSON.parse(cached);

          if (Date.now() < expiresAt) {
            console.log('token is good')
          }
          else {
            console.log('token is bad');
            fetchAgchimpToken();
          }


} else {
  console.log('no cached token')
 fetchAgchimpToken();
}
} else {
  fetchAgchimpToken();
}
}

function fetchAgchimpToken() {
  console.log('getting token');
  var settings = {
  "url": "https://actokenproxy.azurewebsites.net/api/GetJWT?environment=production&code=8KaNGSf95raQUIqHgtLemS9itpRjVsV3u3kZt9ajIpWHAzFuH6t--A==",
  "method": "GET",
  "timeout": 0,
 
};

$.ajax(settings).done(function (response) {
  console.log(response);

  
  const tokenData = {
    token: response.userJwtToken,                    // ← adjust key if needed
    expiresAt: Date.now() + (60 * 60 * 1000) // 1 hour
  };

  localStorage.setItem("agchimpToken", JSON.stringify(tokenData));
  console.log(localStorage['agchimpToken']);
  initAgchimp();
}).fail(function(error){
  console.log(error)
});

}


function initAgchimp() {
  try {
    // Set API base URL in localStorage
    localStorage.setItem('apiBaseUrl', apiBaseUrl);

    // const token = getAgchimpToken();

    // Make token globally available if needed elsewhere
    // window.agchimpToken = token;


    // ✅ ONLY call menu after token is valid

    loadAgChimpMenu();
   

    // Optional product logic
    

  } catch (err) {
    console.error("AgChimp init failed:", err);
  }
};

// function waitForMenuAndLoad(retries = 10) {
//   if (typeof loadAgChimpMenu === "function") {
//     loadAgChimpMenu();
//     if (window.location.pathname.includes("/product")) {
//   if (typeof getProduct === "function") {
//     getProduct();
//   }
// }
//   } else if (retries > 0) {
//     setTimeout(() => waitForMenuAndLoad(retries - 1), 100);
//   } else {
//     console.error("loadAgChimpMenu never loaded");
//   }
// }

// function getStoredAgchimpToken() {
//   const raw = localStorage.getItem("agchimpToken");
//   if (!raw) return null;

//   try {
//     const parsed = JSON.parse(raw);
//     return parsed.token || null;
//   } catch {
//     return null;
//   }
// }